/**
 * @deprecated Use ./assets
 */
export * from './assets';
